import React from 'react';
import { ROUTES } from '../../constant/Routes';

const ResponsiveBannerForCollogue = () => {
  const BannerContent = {
    bannerText: '! برای دیدن قیمت همکار کلیک کنید',
    backgroundColor: '#01494b',
    textColor: '#fff',
  };

  return (
    <div className='gold-banner-container'>
      <div className='gold-banner-wrapper'>
        <a
          href={ROUTES.PERSONAL_INFO}
          className='gold-banner-content'
          style={{
            backgroundColor: BannerContent.backgroundColor,
            color: BannerContent.textColor,
            display: 'block',
            textDecoration: 'none',
          }}
        >
          <h1
            className='gold-banner-heading'
            style={{
              color: BannerContent.textColor,
            }}
          >
            {BannerContent.bannerText}
          </h1>
        </a>
      </div>
    </div>
  );
};

export default ResponsiveBannerForCollogue;
